import { render } from "./LabReport.vue?vue&type=template&id=866dad4e&scoped=true"
import script from "./LabReport.vue?vue&type=script&lang=js"
export * from "./LabReport.vue?vue&type=script&lang=js"

import "./LabReport.vue?vue&type=style&index=0&id=866dad4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866dad4e"]])

export default __exports__